import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ERoutes } from 'src/app/core/enums/routes.enum';

import { AuthService } from 'src/app/core/services/auth.service';
import { BreakpointService } from 'src/app/core/services/breakpoint.service';
import { TestimonialsService } from 'src/app/core/services/testimonials.service';
import { GoogleAnalyticService } from 'src/app/core/services/google-analytic.service';
import { MetaTagsConfigService } from 'src/app/core/services/meta-tags-config.service';

import { AiChatDialogComponent } from 'src/app/shared/components/ai-chat-dialog/ai-chat-dialog.component';

@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    styleUrls: ['./about-us.component.scss'],
    standalone: false
})
export class AboutUsComponent implements OnDestroy {
  tripsStatistic = [
    {
      icon: 'assets/svg/ic-earth-europe.svg',
      value: '70',
      text: 'Countries',
    },
    {
      icon: 'assets/svg/ic-map-location.svg',
      value: '81,894',
      text: 'Destinations',
    },
    {
      icon: 'assets/svg/ic-route.svg',
      value: 'Over 3 million',
      text: 'trip planned',
    },
  ];

  constructor(
    private matDialog: MatDialog,
    private metaTagsConfigService: MetaTagsConfigService,
    private testimonialsService: TestimonialsService,
    protected readonly breakpointService: BreakpointService,
    private readonly googleAnalyticService: GoogleAnalyticService,
    private readonly authService: AuthService,
  ) {
    metaTagsConfigService.setMetaTags(ERoutes.ABOUT_US);
  }

  ngOnDestroy(): void {
    this.metaTagsConfigService.removeMetaTags();
  }

  openAiDialog(): void {
    this.matDialog
      .open(AiChatDialogComponent, {
        width: '96vw',
        maxWidth: '1920px',
      })
      .afterClosed()
      .subscribe(() => {
        this.googleAnalyticService.setCloseAiPlan({
          userID: this.authService.userId,
        });
      });
  }
}
